import { render } from "./OnDuty.vue?vue&type=template&id=4372766a&scoped=true"
import script from "./OnDuty.vue?vue&type=script&lang=js"
export * from "./OnDuty.vue?vue&type=script&lang=js"

import "./OnDuty.vue?vue&type=style&index=0&id=4372766a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4372766a"]])

export default __exports__